import { Injectable } from '@angular/core';
import { Client } from './client';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Subject, Observable } from 'rxjs';
import { pluck } from 'rxjs/operators';
import { forkJoin } from 'rxjs/observable/forkJoin';

@Injectable()
export class DriverService {
  private createDriversource = new BehaviorSubject({ id: '', created_at: '' });
  createdDriver = this.createDriversource.asObservable();
  private editDriverSource = new BehaviorSubject({ id: '', created_at: '' });
  editingDriver = this.editDriverSource.asObservable();
  private lockUnlockUserSource = new BehaviorSubject({ id: '', service_id: '', is_blocked: '' });
  lockUnlockUser = this.lockUnlockUserSource.asObservable();
  private blockUserSource = new BehaviorSubject({ id: '', service_id: '' });
  blockingUser = this.blockUserSource.asObservable();
  private driverCommentSource = new BehaviorSubject<string>('');
  driverComment = this.driverCommentSource.asObservable();
  emitBalanceAfterPenalty = new Subject<{ id: string; balance: number }>();

  constructor(private http: HttpClient, private client: Client) {}

  emittDriverComment(comment: string) {
    return this.driverCommentSource.next(comment);
  }

  emitBlockUserEvent(obj) {
    return this.blockUserSource.next(obj);
  }

  emitLockUnlockUser(obj) {
    return this.lockUnlockUserSource.next(obj);
  }
  emitEditingDriver(user) {
    return this.editDriverSource.next(user);
  }

  emitCreatedNewUser(user) {
    return this.createDriversource.next(user);
  }

  driverReplenish(id: string, summ: number, service: number) {
    console.log(arguments);
    return this.http.post(this.client.getDriverReplenishUrl(), {
      id: id,
      amount: summ,
      service: service
    });
  }

  driverMinus(id: string, summ: number, service: number) {
    return this.http.post(this.client.getDriverMinusUrl(), {
      id: id,
      amount: summ,
      service: service
    });
  }

  getTariffPlansList(obj) {
    return this.http.get(this.client.getTariffPlanListUrl(obj));
  }

  editDriverPin(obj) {
    return this.http.put(this.client.getDriverPinUrl(), obj);
  }

  driverBlock(obj) {
    return this.http.post(this.client.getDriverBlockUrl(), obj);
  }

  driverUnblock(obj) {
    return this.http.post(this.client.getDriverUnblockUrl(), obj);
  }

  getDrivers(obj) {
    // Get
    return this.http.get(this.client.getDriversUrl(), { params: new HttpParams({ fromObject: obj }) });
  }

  getDriversQuery(obj) {
    return this.http.get(this.client.getCabsQuery(obj), { params: new HttpParams({ fromObject: obj }) });
  }

  loadXLS(obj) {
    return this.http.get('/operator/driver/download', {
      params: new HttpParams({ fromObject: obj }),
      headers: new HttpHeaders('Content-Type:application/x-www-form-urlencoded'),
      responseType: 'blob'
    });
  }

  getDriver(obj) {
    // Get id of driver
    return this.http.get(this.client.getDriverUrl(obj));
  }

  getDriverCars(obj) {
    return this.http.get(this.client.getDriverCarsUrl(obj));
  }

  getDriverReqs(driverId: string, serviceId: number): Observable<any> {
    return forkJoin([
      this.getDriver({
        id: driverId,
        service: serviceId
      }).pipe(pluck('data')),
      this.getDriverCars({
        service: serviceId,
        id: driverId
      }).pipe(pluck('data'))
    ]);
  }

  getBlockHistory(obj) {
    return this.http.get(this.client.getBlockHistoryUrl(obj));
  }

  getDriverFiredReasons(obj) {
    return this.http.get(this.client.getDriverFiredReasonsUrl(obj));
  }

  // getBlockReason(obj) {
  //   return this.http.get(this.client.getDriverBlockReasonUrl(obj));
  // }

  getDriverFire(body) {
    let httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      })
    };

    return this.http.post(this.client.getDriverFireUrl(), JSON.stringify(body), httpOptions);
  }

  getDriverStatus(obj) {
    return this.http.get(this.client.getDriverStatusesUrl(obj));
  }

  createDriver(obj) {
    console.log('create');
    return this.http.post(this.client.getDriverCreateUrl(), obj);
  }

  editDriver(obj) {
    return this.http.post(this.client.getDriverUpdateUrl(), obj);
  }

  sendLoginCode(obj) {
    return this.http.post(this.client.getDriverSentCodeUrl(), obj);
  }

  uploadPhoto(obj) {
    return this.http.post(this.client.getUploadImgUrl(), obj);
  }

  getDriverBlockStatus(obj) {
    return this.http.get(this.client.getDriverStatusUrl(obj));
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/driver.service.ts